<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col w-full mb-2">
            <vs-button @click="openEditContentItemPopup" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewItem") }}
            </vs-button>
          </div>
        </div>
        <edit-content-items-popup
          :modelToEdit="modelToEdit"
          :show="showEditContentItemPopup"
          @close="closeEditContentItemPopup"
          @finish="onEditContentItemSuccess"
        ></edit-content-items-popup>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title') },
                { title: $t('Subtitle') },
                { title: $t('Published') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.title }}
                </td>
                <td style="width: 22%">
                  {{ row.subTitle }}
                </td>
                <td style="width: 15%">
                  <div class="flex w-full justify-center items-center">
                    <vs-checkbox
                      :checked="row.published"
                      disabled
                    ></vs-checkbox>
                  </div>
                </td>
                <td style="width: 30%">
                  <div
                    class="w-full h-full flex justify-center items-center gap-2"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="flex gap-2 p-1 px-3"
                      @click="onEditContentItemButton(row)"
                      >{{ $t("Edit") }}</vs-button
                    >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="flex gap-2 p-1 px-3"
                      @click="onItemAttachmentsButton(row)"
                      >{{ $t("Attachments") }}</vs-button
                    >
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteContentItem(row.id)"
                      class="d-inline"
                    ></vs-button>
                  </div>
                </td>
              </template>
            </data-grid>
            <item-attachments-popup
              :modelToEdit="modelToEdit"
              :show="showItemAttachmentsPopup"
              @close="closeItemAttachmentsPopup"
              @finish="onItemAttachmentsSuccess"
            ></item-attachments-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import EditContentItemsPopup from "./EditContentItemsPopup.vue";
import ItemAttachmentsPopup from "./ItemAttachmentsPopup.vue";

export default {
  name: "ContentManagement_Contents_ContentItems",

  components: {
    EditContentItemsPopup,
    ItemAttachmentsPopup,
    DataGrid,
  },
  data() {
    return {
      modelToEdit: {},
      showEditContentItemPopup: false,
      showItemAttachmentsPopup: false,
      gridDataSource: {
        type: "app",
        service: "CMS/api/ContentsQuery/items/" + this.$route.params.id,
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeContentItem: "contentType/deleteContentItem",
    }),
    //Open Modal In Create Mode
    openEditContentItemPopup() {
      this.showEditContentItemPopup = true;
    },
    openItemAttachmentsPopup() {
      this.showItemAttachmentsPopup = true;
    },
    closeEditContentItemPopup() {
      this.showEditContentItemPopup = false;
      this.modelToEdit = {};
    },
    closeItemAttachmentsPopup() {
      this.showItemAttachmentsPopup = false;
      this.modelToEdit = {};
    },
    onEditContentItemSuccess() {
      this.closeEditContentItemPopup();
      this.$refs.grid.renderGrid(1, true);
    },
    onItemAttachmentsSuccess() {
      this.closeItemAttachmentsPopup();
      this.$refs.grid.renderGrid(1, true);
    },
    onEditContentItemButton(item) {
      this.modelToEdit = item;
      this.openEditContentItemPopup();
    },
    onItemAttachmentsButton(item) {
      this.modelToEdit = item;
      this.openItemAttachmentsPopup();
    },
    deleteContentItem(id) {
      // inja delete image
      const payload = {
        contentId: this.$route.params.id,
        id,
      };
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeContentItem(payload).then((response) => {
            if (response) {
              this.renderGrid();
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت حذف شد!",
                showConfirmButton: false,
                timer: 2000,
              });
            }
          });
        }
      });
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 300);
    },
  },
};
</script>

<style scoped></style>
